import moment from 'moment';

import {
    ADD_END_DATE_FOR_DATES_INTERVAL_EDITOR,
    AddEndDateForDatesIntervalEditor,
    CHANGE_END_DATE_FOR_DATES_INTERVAL_EDITOR,
    CHANGE_END_TIME_FOR_DATES_INTERVAL_EDITOR,
    CHANGE_START_DATE_FOR_DATES_INTERVAL_EDITOR,
    CHANGE_START_TIME_FOR_DATES_INTERVAL_EDITOR,
    ChangeStartDateForDatesIntervalEditor,
    DatesIntervalEditorAction,
    DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR,
    UPDATE_DATES_INTERVAL_EDITORS
} from '../actions/datesIntervalEditor';
import { DatesIntervalEditorsState } from '../typings/datesInterval';
import { State } from '../typings/state';

const changeStartDateForDatesIntervalEditor = (
    state: DatesIntervalEditorsState,
    action: ChangeStartDateForDatesIntervalEditor
): DatesIntervalEditorsState => {
    const editor = state[action.editorId];
    const { endDate } = editor;

    const newEndDate =
        endDate !== undefined ? moment.max(action.date, endDate) : endDate;

    return {
        ...state,
        [action.editorId]: {
            ...editor,
            startDate: action.date,
            endDate: newEndDate
        }
    };
};

const addEndDateForDatesIntervalEditor = (
    state: DatesIntervalEditorsState,
    action: AddEndDateForDatesIntervalEditor
): DatesIntervalEditorsState => {
    const editor = state[action.editorId];
    const { startDate } = editor;

    const newEndDate = moment.max(startDate, moment().startOf('day'));

    return {
        ...state,
        [action.editorId]: {
            ...editor,
            endDate: newEndDate
        }
    };
};

export function datesIntervalEditor(
    state: DatesIntervalEditorsState = {},
    action: DatesIntervalEditorAction,
    fullState: State
): DatesIntervalEditorsState {
    switch (action.type) {
        case UPDATE_DATES_INTERVAL_EDITORS:
            return {
                ...state,
                ...action.editors
            };

        case CHANGE_START_DATE_FOR_DATES_INTERVAL_EDITOR:
            return changeStartDateForDatesIntervalEditor(state, action);

        case CHANGE_END_DATE_FOR_DATES_INTERVAL_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    endDate: action.date
                }
            };

        case CHANGE_START_TIME_FOR_DATES_INTERVAL_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    startTime: action.time
                }
            };

        case CHANGE_END_TIME_FOR_DATES_INTERVAL_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    endTime: action.time
                }
            };

        case ADD_END_DATE_FOR_DATES_INTERVAL_EDITOR:
            return addEndDateForDatesIntervalEditor(state, action);

        case DELETE_END_DATE_FOR_DATES_INTERVAL_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    endDate: undefined,
                    endTime: undefined
                }
            };

        default:
            return state;
    }
}
